import React from 'react';
import { TodoList } from '../../components/TodoList';

const TodosPage = () => (
  <div className="todo-page">
    <TodoList />
  </div>
);

export default TodosPage;
